import { render, staticRenderFns } from "./ResetComp.vue?vue&type=template&id=0e5c4a63"
import script from "./ResetComp.vue?vue&type=script&lang=js"
export * from "./ResetComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports